<template>
  <div
    class="icon-container"
    :class="{
      'icon-container--warning': props.type === 'warning',
      'icon-container--success': props.type === 'success',
    }"
  >
    <slot />
  </div>
</template>

<script setup>
const props = defineProps({
  type: {
    type: String,
    default: 'warning',
  },
});
</script>

<style scoped lang="scss">
.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  border-radius: 50%;

  &--warning {
    background-color: var(--fh-color-bg-warning-subtle-default);
  }

  &--success {
    background-color: var(--fh-color-bg-success-subtle-default);
  }
}
</style>
